import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthContext';
import { cn } from '@/lib/cn';
import { moduleTabsFor } from '@/nav/navigation';

/**
 * The second level of a module, under the top bar.
 *
 * The sidebar lists modules — Pre-Construction, Projects, Site Management,
 * Company — and each module's screens sit here as tabs, so the menu stays short
 * and every screen keeps its own URL (client round 4). Rendered once by the
 * shell, so a screen joins its module by naming it in the nav tree.
 */
export function ModuleTabs() {
  const location = useLocation();
  const { user } = useAuth();
  const tabs = moduleTabsFor(location.pathname, { feedback: Boolean(user?.feedback_access), executive: Boolean(user?.executive_access), finance: Boolean(user?.finance_access) });

  if (!tabs) return null;

  return (
    <nav aria-label="Module" className="border-b border-line bg-white px-4 sm:px-6">
      <ul className="-mb-px flex gap-1 overflow-x-auto scrollbar-none">
        {tabs.items.map((item) => {
          const active = tabs.active.id === item.id;
          return (
            <li key={item.id} className="shrink-0">
              <NavLink
                to={item.path}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex h-11 items-center gap-2 border-b-2 px-3 text-sm transition-colors',
                  active ? 'border-accent font-semibold text-ink' : 'border-transparent text-muted hover:border-line hover:text-body',
                )}
              >
                <item.icon aria-hidden className={cn('h-4 w-4', active ? 'text-accent-600' : 'text-muted')} />
                {item.tabLabel ?? item.label}
                {item.attention && <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-gold-500" />}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
